module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./QualificationPageView.js"));
	}, "QualificationPageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QualificationPageView!./src/pages/Shop/Product/QualificationPage/QualificationPageView.js
// module id = 873
// module chunks = 431